import { defineAction } from "rd-action-creators";

export const updateModalStateAction = defineAction<{ modalId: string; newState: boolean }>("UPDATE_MODAL_STATE");
